export default "__VITE_ASSET__DEZLCcaF__"